// app/javascript/controllers/token_search_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list"];

  connect() {
    this.initialized = false;
    this.debouncedSearch = this._debounce(this._search.bind(this), 400);
  }

  focusInput() {
    if (this.hasInputTarget) this.inputTarget.focus();
  }

  inputChanged(event) {
    if (!this.initialized) {
      // mirror original behavior: remove initial list items and the click helper
      document.querySelectorAll(".js-all-tokens-list-item").forEach(el => el.remove());
      document.querySelectorAll(".js-click-to-search-token").forEach(el => el.remove());
      this.initialized = true;
    }
    this.debouncedSearch(event.target.value);
  }

  async _search(term) {
    const trimmed = (term || "").trim();

    if (trimmed.length === 0) {
      this.listTarget.innerHTML = "";
      return;
    }

    const tokenRes = await fetch("/csrf/token", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Accept": "text/plain" }
    })
    if (!tokenRes.ok) throw new Error("Failed to fetch CSRF token")
    const csrfToken = await tokenRes.text()

    fetch("/tokens/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ term: trimmed, authenticity_token: csrfToken })
    })
      .then(r => r.json())
      .then(data => this._renderList(data))
      .catch(err => console.error("Token search failed:", err));
  }

  _renderList(tokens) {
    this.listTarget.innerHTML = "";
    tokens.forEach(token => {
      const blockchain =
        (token.blockchain?.charAt(0)?.toUpperCase() || "") +
        (token.blockchain?.slice(1) || "");

      const card = document.createElement("div");
      card.className = "hover-card w-100 p-2 col-12";
      card.innerHTML = `
        <div class="row d-flex">
          <div class="col-2 ps-2 d-flex align-items-center justify-content-center">
            <img class="rounded-circle" src="${token.image}" style="width: 50px;">
          </div>
          <div class="col-10">
            <div><h4 class="pt-3 m-0">${token.symbol}</h4></div>
            <div class="pb-3">
              <h5 class="lead fw-normal m-0 text-grey">${token.name} on ${blockchain}</h5>
            </div>
          </div>
        </div>`;
      this.listTarget.appendChild(card);
    });
  }

  _debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }
}
